import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { HowItWorks } from "@/components/HowItWorks";
import { Pricing } from "@/components/Pricing";
import { Reviews } from "@/components/Reviews";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";

export default function Landing() {
  const location = useLocation();
  useEffect(() => {
    document.title = "Take The Leap Junk Removal — Hanover, PA";
    const id = location.hash.replace("#", "");
    if (["services", "gallery", "pricing", "reviews", "quote"].includes(id)) {
      const t = setTimeout(() => scrollToId(id), 400);
      return () => clearTimeout(t);
    }
  }, [location.hash]);
  return (
    <div data-testid="landing-page" className="bg-ink font-sans text-zinc-100 antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Gallery />
        <HowItWorks />
        <Pricing />
        <Reviews />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
